/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {CalendarDays, ChevronRight, Crown, Search} from "lucide-react";
import {SiteHeader} from "@/components/SiteHeader";
import {api, authHeaders, money} from "@/lib/inner";

const STATUS = {confirmed: "Terkonfirmasi", arrived: "Tiba", in_service: "Dilayani", completed: "Selesai", cancelled: "Batal", no_show: "Tidak hadir"};

const Row = ({b, onUpdate}) => (
  <div className="table-row" data-testid={`booking-row-${b.code}`}>
    <strong>{b.start_time}<small>{b.end_time} · {b.date}</small></strong>
    <span><b>{b.customer_name}</b><small>{b.code}</small>{b.is_member && <small className="member-chip"><Crown size={10}/> Member</small>}</span>
    <span>{(b.services || [{name: b.service_name}]).map((s, i) => <em className="svc-line" key={i}>{s.name}</em>)}<small>{b.branch_name} · {money(b.price)}</small></span>
    <span className="source">{b.source || "web"}</span>
    <span className={`status ${b.status}`}>{STATUS[b.status]}</span>
    <select data-testid={`booking-status-${b.code}`} value="" onChange={e => onUpdate(b.code, e.target.value)}>
      <option value="" disabled>Ubah status</option>
      <option value="arrived">Tiba</option><option value="in_service">Sedang dilayani</option><option value="completed">Selesai</option><option value="cancelled">Batalkan</option><option value="no_show">Tidak hadir</option>
    </select>
  </div>
);

export default function Dashboard() {
  const [bookings, setBookings] = useState([]), [summary, setSummary] = useState({}), [q, setQ] = useState(""), [status, setStatus] = useState("all");
  const user = JSON.parse(localStorage.getItem("inner_user") || "{}");
  const load = () => {
    api.get("/dashboard/bookings", {...authHeaders(), params: {status, q}}).then(r => setBookings(r.data));
    api.get("/dashboard/summary", authHeaders()).then(r => setSummary(r.data));
  };
  useEffect(load, [status, q]);
  const update = (code, s) => api.patch(`/dashboard/bookings/${code}/status`, {status: s}, authHeaders()).then(load);
  return <>
    <SiteHeader staff/>
    <main className="dashboard">
      <div className="dashboard-head">
        <div><p className="eyebrow" data-testid="dashboard-role-label">{user.role === "admin" ? "ADMIN PUSAT · SEMUA OUTLET" : "RESEPSIONIS · OUTLET " + (user.branch_id || "").replace("-", " ").toUpperCase()}</p><h1>Jadwal <em>hari ini.</em></h1><p className="muted">Kelola kedatangan dan alur perawatan dengan tenang.</p></div>
        <Link className="primary-btn" data-testid="add-booking-button" to="/booking">Tambah Booking <ChevronRight/></Link>
      </div>
      <div className="stat-row">{[["total", "Total booking"], ["completed", "Selesai"], ["cancelled", "Batal"], ["no_show", "Tidak hadir"]].map(([k, t]) => <div className="stat" key={k}><span>{t}</span><strong data-testid={`stat-${k}`}>{summary[k] || 0}</strong></div>)}</div>
      <div className="table-toolbar">
        <div className="search"><Search/><input data-testid="dashboard-search-input" value={q} onChange={e => setQ(e.target.value)} placeholder="Cari nama atau kode booking"/></div>
        <select data-testid="dashboard-status-filter" value={status} onChange={e => setStatus(e.target.value)}><option value="all">Semua status</option>{Object.entries(STATUS).map(([k, v]) => <option value={k} key={k}>{v}</option>)}</select>
      </div>
      <div className="booking-table">
        <div className="table-head"><span>Jam</span><span>Pelanggan</span><span>Perawatan</span><span>Sumber</span><span>Status</span><span/></div>
        {bookings.length ? bookings.map(b => <Row b={b} key={b.code} onUpdate={update}/>) : <div className="empty-table"><CalendarDays/><p>Belum ada booking untuk filter ini.</p></div>}
      </div>
    </main>
  </>;
}
